
export class CorrenteEdicaoZCO {
    constructor(
        dependentes,
        parentesco,
        categorias,
        valoresForm,
        valoresAnterioresForm
    ) {
        this.dependentes = dependentes;
        this.parentesco = parentesco;
        this.categorias = categorias;
        this.arrayMsgsErro = [];
        this.valoresForm = valoresForm;
        this.valoresAnterioresForm = valoresAnterioresForm;
    }

    infringeIdade() {
        if (this.valoresForm.Idade !== this.valoresAnterioresForm.Idade) {
            this.arrayMsgsErro.push('Para este plano, não é possível alterar o campo Idade. Caso seja necessário, exclua o dependente e cadastre-o novamente.');
        }

        return this;
    }

    infringeParentesco() {
        if (this.valoresForm.Parentesco !== this.valoresAnterioresForm.Parentesco) {
            this.arrayMsgsErro.push('Para este plano, não é possível alterar o campo Parenteco.  Caso seja necessário, exclua o dependente e cadastre-o novamente.');
        }

        return this;
    }
}
